import React, { Component } from 'react'
import TabView from '../TabView/TabView'
import Tab from '../TabView/Tab'
import './SidebarStyleMenu.css'
import '../../components/LanguageSelector/LanguageSelector.css'
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector'

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      elementMenu: props.getSidebarTemplateMenu,
      footer: props.getSideBarFooter,
      currentView: 'elementRoot',
      isFixedScrolling: false,
      isMenuOpen: false,
      currentLangFullName: '',
      hide: false,
      langList: ['Polski', 'English', 'Deutsch', 'Français'],
    }
    this.scrollableRef = React.createRef()
  }

  hideLanguageMenu = () => {
    this.setState({isMenuOpen: false});
  }
  toogleLanguageMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }
  changeSidebarTemplateMenu = (getSidebarTemplateMenuHandle) => {
    this.setState({ elementMenu: getSidebarTemplateMenuHandle })
  }
  fixScrolling = (val) => this.setState({ isFixedScrolling: val })

  styleMenuCancel = () => {
    if (typeof this.props.onSettingsRevert === 'function')
      this.props.onSettingsRevert()
    this.onStyleMenuOpenTrigger()
  }
  closeMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }

  onStyleMenuOpenTrigger = () => {
    this.setState({ currentView: 'styleRoot' })
  }

  onStyleMenuCloseTrigger = () => {
    this.setState({ currentView: 'elementRoot' })
  }

  changeView = (viewName) => {
    this.state.currentView === viewName
      ? this.setState({ currentView: 'styleRoot' })
      : this.setState({ currentView: viewName })
  }

  TabViewStyleDisplay = () => {
    if (this.state.currentView === 'colorVariables') {
      return { display: 'none' }
    }
  }

  root = () => <React.Fragment></React.Fragment>

  /**
   * @returns {React.StyleHTMLAttributes}
   */

  containerStyle = () => {
    const isRoot = this.state.currentView === 'elementRoot'
    const isFixedScrolling = this.state.isFixedScrolling

    return {
      flexGrow: 1,
      overflowX: 'hidden',
      overflowY: isFixedScrolling && isRoot ? 'scroll' : 'auto',
    }
  }

  render = () => (
    <React.Fragment>
      <div style={this.containerStyle()} ref={this.scrollableRef}>
        <TabView
          styleDisplay={this.TabViewStyleDisplay()}
          currentTabLabel={
            this.state.currentView === 'styleRoot' ? 'Tab_Style' : null
          }
        >
          <Tab label="Tab_Template" onSelect={this.onStyleMenuCloseTrigger}>
            <div className="template-container">
              {this.state.elementMenu && this.state.elementMenu() }
            
              <LanguageSelector
                langChangeHandler={this.props.onLangChange}
                lang={this.props.currentLang}
              />
            </div>
          </Tab>

          <Tab label="Tab_Style" onSelect={this.onStyleMenuOpenTrigger}>
          </Tab>
        </TabView>   
      </div>
    </React.Fragment>
  )

  /**
   * @returns {React.StyleHTMLAttributes}
   */

}
export default Sidebar;


// WEBPACK FOOTER //
// ./src/containers/Sidebar/Sidebar.js